import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { ITimeCard } from '../itime-card';

export const getTimeCards = createAction(
    '[TimeCard/API] Get TimeCards',
    props<{
        EmployeeListID: string;
        TimeCardDate: string;
        MyDirection: string;
        Processid?: number;
        MinEntryDate?: Date;
        EndDate?: Date;
    }>()
);

export const putTimeCards = createAction(
    '[TimeCard/API] Put TimeCards',
    props<{ timeCard: Array<ITimeCard>; requireTimeSubmit?: boolean }>()
);

// these are only for manipulating the store collection, not for effects, i.e. loading from a service // For reducer

export const loadTimeCards = createAction(
    '[TimeCard/API] Load TimeCards',
    props<{ timeCards: ITimeCard[] }>()
);

export const addTimeCard = createAction(
    '[TimeCard/API] Add TimeCard',
    props<{ timeCard: ITimeCard }>()
);

export const upsertTimeCard = createAction(
    '[TimeCard/API] Upsert TimeCard',
    props<{ timeCard: ITimeCard }>()
);

export const addTimeCards = createAction(
    '[TimeCard/API] Add TimeCards',
    props<{ timeCards: ITimeCard[] }>()
);

export const upsertTimeCards = createAction(
    '[TimeCard/API] Upsert TimeCards',
    props<{ timeCards: ITimeCard[] }>()
);

export const updateTimeCard = createAction(
    '[TimeCard/API] Update TimeCard',
    props<{ timeCard: Update<ITimeCard> }>()
);

export const updateTimeCards = createAction(
    '[TimeCard/API] Update TimeCards',
    props<{ timeCards: Update<ITimeCard>[] }>()
);

export const deleteTimeCard = createAction(
    '[TimeCard/API] Delete TimeCard',
    props<{ id: string }>()
);

export const deleteTimeCards = createAction(
    '[TimeCard/API] Delete TimeCards',
    props<{ ids: string[] }>()
);

export const clearTimeCards = createAction('[TimeCard/API] Clear TimeCards');
